//* Local or Custom Libraries
import { constructSizes, Image } from "@lululemon/ui-library";

//* Importing Styles
import styles from "../bopis-modal.module.scss";

/**
 * @param {object} activeSku - an object containing information about the current item.
 * @param {string} productImage - a string with the product image URL.
 * @param {string} productName - a string with the product name.
 */
const BopisModalHeader = ({
  activeSku,
  productImage,
  productName,
  maxWidths
}) => {
  return (
    <div className={styles.productHeaderContainer}>
      <div>
        <Image
          lazy={false}
          src={productImage}
          alt={productName}
          maxWidth={1800}
          sizes={constructSizes([
            { breakpoint: `${maxWidths.tablet}px`, slotSize: "7vw" },
            { breakpoint: `${maxWidths.mobile}px`, slotSize: "6vw" },
            { slotSize: "21vw" }
          ])}
        />
      </div>
      <div className={styles.productDescription}>
        <h1>{productName}</h1>
        <p className={styles.productDetail}>
          Size
          <span aria-hidden="true">: </span>
          {activeSku?.size}
        </p>
        <p className={styles.productDetail}>{activeSku?.color?.name}</p>
      </div>
    </div>
  );
};

export default BopisModalHeader;
